<template>
  <div class="nav-list">
    <NavLink
      v-for="(item, index) in navList"
      :key="index"
      :nav="item"
      @click="handleClickNav(index, item.text)"
    />

    <slot />
  </div>
</template>

<script>
import NavLink from './NavLink'

export default {
  name: 'NavList',
  components: {
    NavLink
  },
  props: {
    // 序号
    order: {
      type: String,
      default: '1'
    },
    navList: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    handleClickNav (index, text) {
      window.mstrace(`Home_SubTab${this.order}_${index + 1}`, 'Home', { click_text: text })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-list {
  display: flex;
  overflow: hidden;
  flex: 5 5 278px;
  flex-wrap: wrap;
}

</style>
